import { render, staticRenderFns } from "./TokenStepup.vue?vue&type=template&id=02c15c34&"
import script from "./TokenStepup.vue?vue&type=script&lang=ts&"
export * from "./TokenStepup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports